import styled from 'styled-components';

export const Content = styled.div`
  padding: 20px;
  box-sizing: border-box;
  }
`;

export const WrapMessage = styled.div`
  width: 100%;
  gap: 20px;
  margin: 0 0 20px 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  color: white;
`;

export const Buttons = styled.div`
  justify-content: space-between;
  display: flex;
`;
